import { render, staticRenderFns } from "./WechatReading.vue?vue&type=template&id=7543e81a&scoped=true&"
import script from "./WechatReading.vue?vue&type=script&lang=js&"
export * from "./WechatReading.vue?vue&type=script&lang=js&"
import style0 from "./WechatReading.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WechatReading.vue?vue&type=style&index=1&id=7543e81a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7543e81a",
  null
  
)

export default component.exports